__turbopack_context__.v({
  "bad": "DeskFeedModule-module__-FR9NG__bad",
  "ok": "DeskFeedModule-module__-FR9NG__ok",
  "status": "DeskFeedModule-module__-FR9NG__status",
  "statusDetail": "DeskFeedModule-module__-FR9NG__statusDetail",
  "statusLabel": "DeskFeedModule-module__-FR9NG__statusLabel",
  "statusMark": "DeskFeedModule-module__-FR9NG__statusMark",
  "warn": "DeskFeedModule-module__-FR9NG__warn",
});
